<template>
    <div class="login-dashboard-popup">
        <div class="login-dashboard-popup-link" @click="actionBackToDashboard">Dashboard</div>
        <login-dashboard-popup-platform v-for="(platform, key) in availablePlatforms" :data="platform" :key="key"/>
    </div>
</template>

<script>
    import LoginDashboardPopupPlatform from "./LoginDashboardPopupPlatform";
    import Dashboard from "../../new/pages/Dashboard";
    import {mapGetters, mapMutations} from "vuex";

    export default {
        name: "LoginDashboardPopup",
        components: {LoginDashboardPopupPlatform},
        mixins: [Dashboard],
        computed: {
            platformSlug() {
                return this.$route.params.platform ?? '';
            },
            user() {
                return this.authenticatedInitData.user ?? {};
            },
            appAccesses() {
                return this.user.accesses ?? [];
            },
            availablePlatforms() {
                return this.platforms.filter(platform => {
                    return platform.slug !== this.platformSlug;
                });
            },
            ...mapGetters('app', {
                authenticatedInitData: 'getAuthenticatedInitData',
            })
        },
        data() {
            return {
                hostUrl: ''
            }
        },
        methods: {
            actionBackToDashboard() {
                window.top.postMessage({action: 'dashboard'}, '*');
            },
            calculateHeight() {
                let height = 0;

                this.appAccesses.forEach(appAccess => {
                    if (appAccess.hasAccess) {
                        height += 36;
                    }
                });

                return height;
            },
            ...mapMutations('app', {
                setAuthenticatedInitData: 'setAuthenticatedInitData',
                setGlobalLoadingState: 'setGlobalLoadingState',
            }),
        },
        mounted() {
            this.setGlobalLoadingState(true);
            this.$api.authenticatedInit().then(({data}) => {
                this.setAuthenticatedInitData(data);
                window.top.postMessage({action: 'height', height: this.calculateHeight()}, '*');
            }).finally(() => {
                this.setGlobalLoadingState(false);
            });
        }
    }
</script>

<style lang="scss">
    @import "../scss/variables";

    .login-dashboard-popup {
        width: 100%;
        box-sizing: border-box;
        background-color: #f5f5f5;

        .login-dashboard-popup-link {
            display: flex;
            align-items: center;
            height: 36px;
            padding: 0 12px;
            box-sizing: border-box;
            color: #444;
            transition: $transition;
            cursor: pointer;
            font-size: 14px;
            font-weight: 400;

            &:hover {
                background-color: #e5e5e5;
                color: #000;
            }
        }
    }
</style>